<ifc-error-base-page [errorImgType]="ErrorImgType.PageNotFound">
  <ng-template #title>
    Sorry, page not found.
  </ng-template>

  <ng-template #description>
    We can't find a page with the url you entered.
  </ng-template>
</ifc-error-base-page>
